import { Link } from 'react-router-dom';

export default function DJFooter() {
  return (
    <footer className="bg-dj-darker py-10 px-[10%] border-t border-[#333] text-dj-silver">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center md:items-start justify-between gap-6 text-center md:text-left">
        <div>
          <p className="text-white font-semibold mb-1">D&amp;J Records</p>
          <p>36 George Street, Bathgate</p>
          <p>West Lothian, EH48 1PD</p>
          <a href="mailto:info@dandjrecords.co.uk" className="block mt-2 text-dj-blue hover:underline">
            info@dandjrecords.co.uk
          </a>
          <a href="tel:+447754344864" className="block mt-1 text-dj-blue hover:underline">
            +44 7754 344864
          </a>
          <div className="flex justify-center md:justify-start gap-5 mt-3">
            <a
              href="https://www.facebook.com/profile.php?id=61576941160531"
              target="_blank"
              rel="noreferrer"
              aria-label="D&J Records on Facebook"
              className="text-dj-silver text-2xl hover:text-dj-red transition-colors"
            >
              <i className="fab fa-facebook" />
            </a>
            <a
              href="https://www.tiktok.com/@dandjrecordsbathgate"
              target="_blank"
              rel="noreferrer"
              aria-label="D&J Records on TikTok"
              className="text-dj-silver text-2xl hover:text-dj-red transition-colors"
            >
              <i className="fab fa-tiktok" />
            </a>
          </div>
        </div>
        <div className="flex flex-col items-center md:items-end gap-2 self-center">
          <p className="text-sm">&copy; 2026 D&amp;J Records. Keeping the groove alive.</p>
          <Link to="/privacy-policy" className="text-sm text-dj-silver hover:text-dj-blue transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="text-sm text-dj-silver hover:text-dj-blue transition-colors">
            Terms &amp; Conditions
          </Link>
          <a
            href="https://inte.team"
            target="_blank"
            rel="noreferrer"
            className="text-sm text-dj-silver hover:text-dj-blue transition-colors"
          >
            Built by Inte.Team
          </a>
          <div className="flex items-center gap-2 mt-1" aria-label="Accepted payment methods">
            {/* Visa */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 750 471"
              width="38"
              height="24"
              role="img"
              aria-label="Visa"
            >
              <rect width="750" height="471" rx="40" fill="#fff" />
              <path d="M278 334l45-265h72L350 334h-72zM524 75c-14-6-37-12-65-12-71 0-122 36-122 87 0 38 35 59 62 72 27 13 37 21 37 33 0 17-22 25-43 25-28 0-44-4-67-14l-9-4-10 59c17 7 47 14 79 14 75 0 124-35 124-89 0-30-19-52-60-71-25-12-40-20-40-33 0-11 13-23 41-23 23 0 40 5 53 11l6 3 10-58zM661 70h-55c-17 0-30 5-37 22L456 334h76l15-40h92l9 40h67L661 70zm-89 170l28-73 9-24 5 22 17 75h-59zM205 70l-70 181-8-38C113 163 73 118 28 97l64 237h77L282 70h-77z" fill="#1a1f71" />
              <path d="M107 70H0l-1 6c83 20 138 69 161 127L137 93c-4-16-16-22-30-23z" fill="#f9a533" />
            </svg>
            {/* Mastercard */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 750 471"
              width="38"
              height="24"
              role="img"
              aria-label="Mastercard"
            >
              <rect width="750" height="471" rx="40" fill="#fff" />
              <circle cx="280" cy="236" r="165" fill="#eb001b" />
              <circle cx="470" cy="236" r="165" fill="#f79e1b" />
              <path d="M375 106a165 165 0 0 1 0 260 165 165 0 0 1 0-260z" fill="#ff5f00" />
            </svg>
            {/* American Express */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 750 471"
              width="38"
              height="24"
              role="img"
              aria-label="American Express"
            >
              <rect width="750" height="471" rx="40" fill="#016FD0" />
              <text
                x="375"
                y="290"
                fontFamily="Arial, sans-serif"
                fontSize="130"
                fontWeight="bold"
                fill="white"
                textAnchor="middle"
              >
                AMEX
              </text>
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
}
